var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ai-tips-content-wrapper" },
    [
      _c("h3", { staticClass: "mt-0 mb-2 font-outfit-medium" }, [
        _vm._v(" " + _vm._s(_vm.title) + " "),
      ]),
      !_vm.isOpened
        ? [
            _c(
              "vue-typed-js",
              {
                attrs: {
                  "content-type": "html",
                  "show-cursor": false,
                  shuffle: false,
                  strings: [_vm.stringToRender],
                  "start-delay": 500,
                  "type-speed": 5,
                },
                on: { onComplete: _vm.onComplete },
              },
              [_c("div", { staticClass: "typing" })]
            ),
          ]
        : [_c("div", { domProps: { innerHTML: _vm._s(_vm.stringToRender) } })],
      _c("div", { staticClass: "d-flex justify-content-start" }, [
        _c("p", { staticClass: "disclaimer-text font-outfit-light" }, [
          _vm._v(" " + _vm._s(_vm.$t("aiDisclaimer")) + " "),
        ]),
      ]),
      _c("v-divider"),
      _c(
        "div",
        { staticClass: "d-flex justify-content-end" },
        [
          _c(
            "ib-button-basic",
            {
              attrs: { color: "gray" },
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            },
            [
              _c("span", { staticClass: "font-outfit-light" }, [
                _vm._v(_vm._s(_vm.$t("aiBuddy.close"))),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }